import { SignIn } from "@clerk/remix";

import useLandingUrl from "~/hooks/use-landing-url";

export default function SignInPage() {
  return <SignIn forceRedirectUrl={useLandingUrl()} />;
}
